import React, { useState, useContext, useEffect } from "react"
import styled from "styled-components"
import { FaCalendar } from "@react-icons/all-files/fa/FaCalendar"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import * as journeyJson from "../../../static/journeyssr.json"
import {
  uploadDocument,
  finalSubmission,
  fetchAllJourneyData,
  getS3FilenetUpload,
  saveApplication,
  finarkeinGenerateLink,
  finarkeinStatus,
  getDocuments,
  fetchDigilockerDetails,
  aesEncryptData,
  retreiveUploadedDocuments,
  s3DownloadDocuments,
  deleteTempDocument,
  uploadTempDocument,
  getAllTempDocuments,
  moveTempDocumentsToPermanentBucket,
  generateAnurVCLink,
  getConfigByType,
} from "../../services/apiservice"
import pdfIcon from "../../../static/images/ekyc2.png"
import * as lookup from "../../../static/lookup.json"
import { withPrefix } from "gatsby"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { perfiosGenerateLink } from "../../services/perfios-api-service"
import { findCurrentJourneyCode } from "../services/helperFunctions"
import { errorToastr, successToastr } from "../../services/error-handler"
import { accessToken } from "../../interceptors/jwt-interceptor"
import base64 from 'base-64'
import Select from "react-select"
import { deepCopy } from "../../shared/functions"
import { error } from "toastr"
var CryptoJS = require("crypto-js");

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 0.6rem 0;
      padding-bottom: 0;
    }
    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
        padding-right: 4px !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background:var(--lumiq-bg)
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

export default function UploadDocuments(props) {
  const [isUploading, setIsUploading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [docNumber, setDocNumber] = useState({
    _UID_: {
      count:1
    },
    _PHO_: {
      count: 1
    },
    _IDP_: {
      count: 1
    },
    _SOW_: {
      count: 1
    },
    _CAP_: {
      count: 1
    },
    _PAP_:{
      count: 1
    },
    _AGP_: {
      count: 1
    },
    _OTH_: {
      count: 1
    },
    _CNF_: {
      count: 1
    },
    ADD2: {
      count: 1
    },
    _COC_: {
      count: 1
    },
    _DDI_: {
      count: 1
    },
  })
  const [docNumberProposer, setDocNumberProposer] = useState({
    _PHO_: {
      count: 1
    },
    _IDP_: {
      count: 1
    },
    _CAP_: {
      count: 1
    },
    _PAP_:{
      count: 1
    },
   })
   const [docNumberjointLife, setDocNumberjointLife] = useState({
    _IDP_:{
      count: 1
    },
    _ADP_: {
      count: 1
    },
  })
   const [uploadedDocuments, setUploadedDocuments] = useState({
    _PHO_: {
      path: "",
      name: "",
      msg: "",
      location : ""
    },
    _UID_: [{
      path: "",
      name: "",
      msg: "",
      location : ""
    }],
    _IDP_: [{
      path: "",
      name: "",
      msg: "",
      location : ""
    }],
    _SOW_: [{
      path: "",
      name: "",
      msg: "",
      location : ""
    }],
    _CAP_: [{
      path: "",
      name: "",
      msg: "",
      location : ""
    }],
    _PAP_:[{
      path: "",
      name: "",
      msg: "",
      location : ""
    }],
    _AGP_: [{
      path: "",
      name: "",
      msg: "",
      location : ""
    }],
    _OTH_: [{
      path: "",
      name: "",
      msg: "",
      location : ""
    }],
    _CNF_: {
      path: "",
      name: "",
      msg: "",
      location : ""
    },
    ADD2: {
      path: "",
      name: "",
      msg: "",
      location : ""
    },
    _BDP_: {
      path: "",
      name: "",
      msg: "",
      location : ""
    },
    _COC_: {
      path: "",
      name: "",
      msg: "",
      location : ""
    },
    _DDI_: {
      path: "",
      name: "",
      msg: "",
      location : ""
    },
  })
  const [responseDocument, setResponseDocument] = useState({
    _PHO_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
    _UID_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _IDP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _SOW_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _CAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _PAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _AGP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _OTH_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _CNF_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
    ADD2: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
    _BDP_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
    _COC_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
    _DDI_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
  })

  const [responseDocumentProposer, setResponseDocumentProposer] = useState({
    
    _CAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _PAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _IDP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _PHO_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
  })
  const [documentPR, setdocumentPR] = useState({
    _CAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name: "",
    }],
    _PAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name: "",
    }],
    _IDP_:[{
      location: "",
      fileName: "",
      msg: "",
      name: "",
    }],
    _PHO_: {
      location: "",
      fileName: "",
      msg: "",
      name: "",
    },
  })
  const [documentforSA, setdocumentforSA] = useState({
    _IDP_: [{
      location: "",
      fileName: "",
      msg: "",
      name: "",
    }],
    _ADP_: [{
      location: "",
      fileName: "",
      msg: "",
      name: "",
    }],
  })

  const [uploadedDocumentsSA, setUploadedDocumentsSA] = useState({
    _IDP_: [{
      path: "",
      name: "",
      msg: "",
      location : ""
    }],
    _ADP_: [{
      path: "",
      name: "",
      msg: "",
      location : ""
    }],
  })

  const [disable, setDisable] = useState(false)
  const [disableAadhar, setDisableAadhar] = useState(false)
  const [disableProposer, setDisableProposer] = useState(false)
  const [disabledMessage, setDisabledMessage] = useState("")
  const [disabledMessageAadhar, setDisabledMessageAadhar] = useState("")
  const [disabledMessageProposer, setDisabledMessageProposer] = useState("") 
  const [addressProceedPermanent, setAddressProceedPermanent] = useState(false)
  const [digilockerLA, setDigilockerLA] = useState(false)
  const [digilockerPR, setDigilockerPR] = useState(false)
  const [digilockerSA, setDigilockerSA] = useState(false)
  const [disableAGP, setdisableAGP] = useState(false)
  const [disableAGPmessage, setdisableAGPmessage] = useState("")
  const [disableAadhaarDL, setdisableAadhaarDL] = useState(false)
  const [disableAadhaarMessage, setdisableAadhaarMessage] = useState("")
  const [disableIDP, setdisableIDP] = useState(false)
  const [disableIDPmessage, setdisableIDPmessage] = useState("")
  const [disableADP, setdisableADP] = useState(false)
  const [disableADPmessage, setdisableADPmessage] = useState("")
  const [disableIDPPR, setdisableIDPPR] = useState(false)
  const [disableIDPPRmessage, setdisableIDPPRmessage] = useState("")
  const [disableADPPR, setdisableADPPR] = useState(false)
  const [disableADPPRmessage, setdisableADPPRmessage] = useState("")
  const [disableIDPSA, setdisableIDPSA] = useState(false)
  const [disableIDPSAmessage, setdisableIDPSAmessage] = useState("")
  const [disableADPSA, setdisableADPSA] = useState(false)
  const [disableADPSAmessage, setdisableADPSAmessage] = useState("")
  const [addressProceedPermanentProposer, setAddressProceedPermanentProposer] = useState(false)
  const [allJourneyData, setAllJourneyData] = useState()
  const [paymentMethod, setPaymentMethod] = useState("")
  const [retreiveUploadedDocumentsData, setRetreiveUploadedDocuments] = useState()
  const [docOptions, setDocOptions] = useState()
  const [selectedOption, setSelectedOption] = useState()
  const [selectedOptionData, setSelectedOptionData ] = useState()
  const [disablePermanentAddress,setDisablePermanentAddress]=useState(false)
  const [permanentAddressDisableMessage,setPermanentAddressDisableMessage]=useState("")
  const [disableProposerPermanentAddress, setDisableProposerPermanentAddress]=useState(false)
  const [permanentProposerAddressDisableMessage,setProposerPermanentAddressDisableMessage]=useState("")
  const [previewImgSrc,setPreviewImgSrc] = useState('')
  const [eventState,setEventState] = useState('')
  const [field,setField] = useState('')
  const [VCOption, setVCOption] = useState('')
  const [anurConfigChannels, setAnurConfigChannels] = useState([])
  const [vcOptionClicked,setVCOptionClicked] =useState(false);
  const [vcTimerActive, setVCTimerActive] = useState(false); // Timer state
  const [vcTimeLeft, setVCTimeLeft] = useState(0); //time left state
  const [vcIdProof, setVcIdProof] = useState(null); // Add state for base64
  const [vcIdProofName, setVcIdProofName] = useState(""); // name of base64 img

  const handleVCIdProofChange = (event) => {
    try {
      const file = event.target.files[0];
      if (!file) return;
      if (!uploadFileValidations(file)) return;
      const formData = new FormData();
      formData.append("image", file);
      setVcIdProof(formData);
      setVcIdProofName(file.name)
    } catch (error) {
      errorToastr(error.message)
      setVcIdProof(null)
      setVcIdProofName("")
    }
  };

  useEffect(() => {
    let timer;
    if (vcTimerActive) {
      setVCTimeLeft(30); // Start at 30 seconds
      timer = setInterval(() => {
        setVCTimeLeft(prev => {
          if (prev <= 1) {
            setVCTimerActive(false);
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      setVCTimeLeft(0);
    }
    return () => clearInterval(timer);
  }, [vcTimerActive]);


  useEffect(() => {
    let payload = {
      journeyId: journeyState.journeyId,
    }
    fetchAllJourneyData(payload).then(res => {
      setAllJourneyData(res)
      console.log(res.lifeAssuredDetails, "fetchAlljourneyData response")
      if(res?.consentHandle){
        let payloadForStatus = {
          "consentHandle": res?.consentHandle
        }
        let finarkein = finarkeinStatus(payloadForStatus)
      }
      if (res.lifeAssuredDetails?.kycVerified === true) {
        setDisable(true)
        setDisableAadhar(true)
        setDisabledMessageAadhar("Waived Off")
        setDisabledMessage("Waived Off")
        if (res.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
          setAddressProceedPermanent(true)
        }
      } else if (res.lifeAssuredDetails?.ckycVerified === true) {
        setDisable(true)
        setDisabledMessage("Waived Off")
        if (res.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
          setAddressProceedPermanent(true)
        }
      } else {
        setDisable(false)
        setDisabledMessage("")
      }
      if (res.lifeAssuredDetails?.proceedWith === "ckyc" && res.lifeAssuredDetails?.proceedWith === "ekyc") {
        if (res.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
          setDisablePermanentAddress(true)
          setPermanentAddressDisableMessage("Waived Off")
        }
      } else if(res.lifeAssuredDetails?.proceedWith === "ckyc" && res.lifeAssuredDetails?.addressProceedWith === "permanentAddress"){
        setDisablePermanentAddress(true)
        setPermanentAddressDisableMessage("Waived Off")
      }
      else if(res.lifeAssuredDetails?.proceedWith === "ekyc" && res.lifeAssuredDetails?.addressProceedWith === "permanentAddress"){
        setDisablePermanentAddress(true)
        setPermanentAddressDisableMessage("Waived Off")
      }
      if (res?.lifeAssuredDetails?.isLaAndPropSame === "N") {
        if (res.proposerDetails?.kycVerified === true && (res.proposerDetails?.addressProceedWith === "both" || res.proposerDetails?.addressProceedWith === "currentAddress")) {
          setDisableProposer(true)
          setDisabledMessageProposer("Waived Off")
          if (res.proposerDetails?.addressProceedWith === "permanentAddress" || res.proposerDetails?.addressProceedWith === "both") {
            setAddressProceedPermanentProposer(true)
          }
        } else if (res.proposerDetails?.ckycVerified === true && (res.proposerDetails?.addressProceedWith === "both" || res.proposerDetails?.addressProceedWith === "permanentAddress")) {
          setDisableProposer(true)
          setDisabledMessageProposer("Waived Off")
          if (res.proposerDetails?.addressProceedWith === "permanentAddress") {
            setAddressProceedPermanentProposer(true)
          }
        } else {
          setDisableProposer(false)
          setDisabledMessageProposer("")
        }

        if (res.proposerDetails?.proceedWith === "ckyc" || res.proposerDetails?.proceedWith === "ekyc") {
          if (res.proposerDetails?.addressProceedWith === "permanentAddress") {
            setDisableProposerPermanentAddress(true)
            setProposerPermanentAddressDisableMessage("Waived Off")
          }
        }
      }
      if(journeyState.digiLockerOption && !(res?.basicDetails?.AGPLA || res?.basicDetails?.IDPLA || res?.basicDetails?.ADPLA || res?.basicDetails?.AadhaarUpload || res?.basicDetails?.AGPSA || res?.basicDetails?.IDPPR || res?.basicDetails?.ADPPR)){
        errorToastr("Documents not available")
      }
      if(res?.basicDetails?.digiLockerRedirectLA){
        if(journeyState.digiLockerOption === "LA" && (res?.basicDetails?.AGPLA || res?.basicDetails?.IDPLA || res?.basicDetails?.ADPLA || res?.basicDetails?.AadhaarUpload)){
          successToastr("Documents uploaded successfully")
        }
        setDigilockerLA(true)
        if(res?.basicDetails?.AGPLA){
          setdisableAGP(true)
          setdisableAGPmessage("Waived Off")
        }
        if(res?.basicDetails?.IDPLA){
          setdisableIDP(true)
          setdisableIDPmessage("Waived Off")
        }
        if(res?.basicDetails?.ADPLA){
          setdisableADP(true)
          setdisableADPmessage("Waived Off")
        }
        if(res?.basicDetails?.AadhaarUpload){
          setdisableAadhaarDL(true)
          setdisableAadhaarMessage("Waived Off")
        }
      }
      if(res?.basicDetails?.digiLockerRedirectSA){
        setDigilockerSA(true)
        if(res?.basicDetails?.IDPSA){
          setdisableIDPSA(true)
          setdisableIDPSAmessage("Waived Off")
        }
        if(res?.basicDetails?.ADPSA){
          setdisableADPSA(true)
          setdisableADPSAmessage("Waived Off")
        }
      }


      if(res?.basicDetails?.digiLockerRedirectPR){
        if(journeyState.digiLockerOption === "PR" && (res?.basicDetails?.IDPPR || res?.basicDetails?.ADPPR)){
          successToastr("Documents uploaded successfully")
        }
        setDigilockerPR(true)
        if(res?.basicDetails?.IDPPR){
          setdisableIDPPR(true)
          setdisableIDPPRmessage("Waived Off")
        }
        if(res?.basicDetails?.ADPPR){
          setdisableADPPR(true)
          setdisableADPPRmessage("Waived Off")
        }
      }

      if(res?.journeyType?.toLowerCase() === "canarapos"){
        retreiveUploadedDocumentsFunction()
      }

      let paymentMethod
      res?.transactionDetails?.transactions?.find((transaction, index) => {
        if (transaction.status === "Success" && transaction?.paymentMethod?.toLowerCase() === "cheque") {
          paymentMethod = "cheque"
        } else if (transaction.status === "Success" && transaction?.paymentMethod?.toLowerCase() === "dd") {
          paymentMethod = "dd"
        }
        setPaymentMethod(paymentMethod)
      })
      let data = {
        applicationNumber: journeyState.applicationNo
      }
      getAllTempDocuments(data)
      .then(documents => {
        // let docList = []
        let docType = ["CAP","PAP", "IDP", "AGP", "SOW", "UID", "PHO", "DDI", "COC", "BDP", "ADD2", "OTH", "CNF","ADP"]
        let tempUploadDocuments = {
          _UID_:[{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _PHO_: {
            path: "",
            name: "",
            msg: "",
            location : ""
          },
          _ADE_: [{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _IDP_: [{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _SOW_: [{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _CAP_: [{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _PAP_:[{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _AGP_: [{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _OTH_: [{
            path: "",
            name: "",
            msg: "",
          }],
          _CNF_: {
            path: "",
            name: "",
            msg: "",
            location : ""
          },
          ADD2: {
            path: "",
            name: "",
            msg: "",
            location : ""
          },
          _BDP_: {
            path: "",
            name: "",
            msg: "",
            location : ""
          },
          _COC_: {
            path: "",
            name: "",
            msg: "",
            location : ""
          },
          _DDI_: {
            path: "",
            name: "",
            msg: "",
            location : ""
          },
        }
        let tempUploadDocumentsProposer = {
          _PHO_: {
            path: "",
            name: "",
            msg: "",
            location : ""
          },
          _IDP_: [{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _CAP_: [{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _PAP_:[{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
        }
        let tempUploadDocumentsJointLife = {
          _ADP_: [{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
          _IDP_: [{
            path: "",
            name: "",
            msg: "",
            location : ""
          }],
        }
        let tempDocNumberCount = {
          _UID_: {
            count: 1
          },
          _PHO_: {
            count: 1
          },
          _IDP_: {
            count: 1
          },
          _SOW_: {
            count: 1
          },
          _CAP_: {
            count: 1
          },
          _PAP_:{
            count: 1
          },
          _AGP_: {
            count: 1
          },
          _OTH_: {
            count: 1
          },
          _CNF_: {
            count: 1
          },
          ADD2: {
            count: 1
          },
          _COC_: {
            count: 1
          },
          _DDI_: {
            count: 1
          },
        }
        let tempDocNumberCountProposer = {
          _PHO_: {
            count: 1
          },
          _IDP_: {
            count: 1
          },
          _CAP_: {
            count: 1
          },
          _PAP_:{
            count: 1
          },
        }
        let tempDocNumberCountJointLife = {
          _ADP_: {
            count: 1
          },
          _IDP_: {
            count: 1
          },
        }
        documents?.data?.documents.map(doc => {
          if(docType.includes(doc.docPurpose) && doc.active){
            let location = doc.path
            let encryptedToken = aesEncryptData({ accessToken: accessToken })
            let base64EncodedToken = base64.encode(encryptedToken)
            // console.log("base64EncodedToken", base64EncodedToken)
            let newLocation = `${location}?auth=${base64EncodedToken}`
            doc.path = newLocation
            // let obj = {
            //   [`_${doc.docPurpose}_`]: doc
            // }
            // docList.push(obj)
            }
            const singleDoc = ["PHO","CNF","COC","DDI","ADD2","ADD2","BDI"]
            if(docType.includes(doc.docPurpose)){
              if (doc.option === "LA"){
                if (!singleDoc.includes(doc.docPurpose)){
                  tempDocNumberCount[`_${doc.docPurpose}_`].count++;
                }else{
                  tempDocNumberCount[`_${doc.docPurpose}_`].count = 1;
                }
              }else if (doc.option === "SA"){
                if (!singleDoc.includes(doc.docPurpose)){
                  tempDocNumberCountJointLife[`_${doc.docPurpose}_`].count++;
                }else{
                  tempDocNumberCountJointLife[`_${doc.docPurpose}_`].count = 1;
                }
              }else if (doc.option === "PR"){
                if (!singleDoc.includes(doc.docPurpose)){
                  tempDocNumberCountProposer[`_${doc.docPurpose}_`].count++;
                }else{
                  tempDocNumberCountProposer[`_${doc.docPurpose}_`].count = 1;
                }
              }
            if(doc.option === "LA"){
              if (doc.docPurpose === "PHO" || doc.docPurpose === "ADD2" || doc.docPurpose === "COC" || doc.docPurpose === "DDI" || doc.docPurpose === "CNF"){
                tempUploadDocuments[`_${doc.docPurpose}_`] = doc
              }else{
                tempUploadDocuments[`_${doc.docPurpose}_`] = [
                  ...tempUploadDocuments[`_${doc.docPurpose}_`],
                  doc
                ]
              }
            } else if(doc.option === "PR"){
              if (doc.docPurpose === "PHO"){
                tempUploadDocumentsProposer[`_${doc.docPurpose}_`] = doc
              }else{
                tempUploadDocumentsProposer[`_${doc.docPurpose}_`] = [
                  ...tempUploadDocumentsProposer[`_${doc.docPurpose}_`],
                  doc
                ]
              }
            } else{
              {
                tempUploadDocumentsJointLife[`_${doc.docPurpose}_`] = [
                  ...tempUploadDocumentsJointLife[`_${doc.docPurpose}_`],
                  doc
                ]
              }
            }
          }
        })
        setUploadedDocuments(prev => ({
          ...prev,
          ...tempUploadDocuments
        }))
        setDocNumber(prev => {
          return {
            ...prev,
            ...tempDocNumberCount
          }
        })
        setdocumentPR(prev => ({
          ...prev,
          ...tempUploadDocumentsProposer
        }))
        setDocNumberProposer(prev => {
          return {
            ...prev,
            ...tempDocNumberCountProposer
          }
        })
        setUploadedDocumentsSA(prev => ({
          ...prev,
          ...tempUploadDocumentsJointLife
        }))
        setDocNumberjointLife(prev => {
          return {
            ...prev,
            ...tempDocNumberCountJointLife
          }
        })
      })
    })
  }, [])

  useEffect(()=>{
    if(allJourneyData){
       getConfigByType({type:"anur-config"}).then(res=>{
      if(res?.data[0]?.config?.products?.hasOwnProperty(allJourneyData?.journeyIdFromStrapi)){
        let channels=res?.data[0]?.config?.products?.[allJourneyData?.journeyIdFromStrapi]?.channels || [];
        channels=channels.map(c=>c.toUpperCase());
        setAnurConfigChannels(channels)
      }
    }).catch(error=>{
      console.error(error)
      errorToastr(error?.response?.data?.message || error.message)
    })
    }
  },[allJourneyData])

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [errorState, setErrorState] = useState("")
  const [bankingOptionSelect, setBankingOptionSelect] = useState("")

  const handleFileEnter = (event, inputId) => {
    if (event.key == 'Enter') {
      let el = document.getElementById(inputId)
      el.click()
    }

  }

  const handlePerfiosEnter = (event) => {
    if (event.key == 'Enter') {
      navigateToPerfiosUrl()

    }
  }

  const handleChangeBankingOption = (event) => {

    if (event.key == "Enter") {
      changeBankingOption(event)

    }
  }

  const handlePreview = (e,field,callbackType) => {
    const fileInput = e.target;
    const file = fileInput.files[0];
    if (file) {
      if (file.type.startsWith('image/')){
        const reader = new FileReader();
        reader.onload = function (e) {
          setPreviewImgSrc(e.target.result)
          const ele = document.getElementById("previewUpload")
          ele.setAttribute("data-type",callbackType)
        };
        reader.readAsDataURL(file);
      }else{
        if (callbackType === "la"){
          uploadFile(e,field,false)
        }else if (callbackType === "pr"){
          uploadFileForProposer(e,field,false)
        }else if (callbackType === "sa"){
          uploadFileForSA(e,field,false)
        }
      }
    }
  }


  const uploadFile = async (e, field,isPreview = false) => {
    if (isPreview){
      handlePreview(e,field,"la")
      setField(field)
      setEventState(e)
      return;
    }

    if(docNumber?.[`${field}`]?.count > 6){
      errorToastr("Maximum 6 images can be Uploaded")
      return
    }
    if (isUploading) {
      return
    }
    let file = e?.target?.files[0]
    console.log(file, "file")
    if (!file) {
      return
    }

    //check for file size
    if (file.size > 5242880) {
      errorToastr("Maximum file sixe allowed is 5 Mb")
      return
    }

    //check for double extension
    let hasDoubleFormat = file.name?.split(".")?.length > 2
    if (hasDoubleFormat) {
      errorToastr("This file is not supported")
      return
    }

    //Check for file format
    let fileFormat = file.name?.split(".")?.[1]
    console.log(fileFormat, "fileFormat")
    if (!fileFormat || !(["png","jpg", "jpeg", "tiff","tif", "pdf"]).includes(fileFormat.toLowerCase())) {
      errorToastr("This file is not supported")
      return
    }

    //Check for null type
    if (file.size < 10) {
      errorToastr("Invalid file")
      return
    }

    //Check for mimetype
    if (!["image/x-png", "image/png", "application/pdf", "image/jpeg", "image/tiff"].includes(file.type)) {
      errorToastr("File not supported")
      return
    }

    let formData = new FormData()
    if (e?.target?.files.length) {
      console.log(e.target.files, "dsskjjsf")
      setIsUploading(true)
      const file = e.target.files[0]
      formData.append("doc", file)
      formData.append("sub", true)
      let name = e.target.files?.[0]?.name || ""
      if(field === "_PHO_"){
        formData.append(
          "docPurpose", Date.now() + "-" +
          field + "." +
        name.split(".")[1]
        )
      }
      else {
        formData.append(
          "docPurpose", Date.now() + "-" +
          field + "0" + docNumber?.[`${field}`]?.count + "." +
        name.split(".")[1]
        )
      }
      formData.append(
        "uploadDocPurpose", field.split("_")[1]
      )
      console.log(formData)

      try {
        let payload = {
          applicationNumber: journeyState.applicationNo,
          option: "LA"
        }
        const res = await uploadTempDocument(formData, payload) //journeyState.applicationNo
        if(res?.location == ''){
          errorToastr("File not supported")
        }
        let location = res.location
        let encryptedToken = aesEncryptData({ accessToken: accessToken })
        let base64EncodedToken = base64.encode(encryptedToken)
        // console.log("base64EncodedToken", base64EncodedToken)
        let newLocation = `${location}?auth=${base64EncodedToken}`
        // console.log("newLocation", newLocation)
        res.location = newLocation
        res.name = name
        console.log({ res })
        const singleDoc = ["_PHO_","_CNF_","_COC_","_DDI_","_ADD2_","_BDP_"]
        if(singleDoc.includes(field))
        {
          setResponseDocument({
            ...responseDocument,
            [field]: res,
           })
        }else {
          if (responseDocument?.[`${field}`].length === 1){
            if (uploadedDocuments?.[`${field}`].length > 1){
              let tempResposneDocument = []
              uploadedDocuments?.[`${field}`]?.map(doc => {
                tempResposneDocument.push({
                  location : doc.path,
                  fileName : doc.name,
                  msg : "",
                  name : doc.name
                })
              })
              setResponseDocument({
                ...responseDocument,
                [field]: [
                  ...tempResposneDocument,
                  res
                ],
              });
            }else{
              setResponseDocument({
                ...responseDocument,
                [field]: [
                  ...responseDocument[`${field}`],
                  res
                ],
              });
            }
          }else{
            setResponseDocument({
              ...responseDocument,
              [field]: [
                ...responseDocument[`${field}`],
                res
              ],
            });
          }
        }
        if (!singleDoc.includes(field)){
          setDocNumber({
            ...docNumber,
            [field]: {
              count: docNumber?.[`${field}`]?.count + 1
            },
          })
        }else{
          setDocNumber({
            ...docNumber,
            [field]: {
              count: 1
            },
          })
        }
        setIsUploading(false)
      } catch (error) {
        setIsUploading(false)
      }
    }
  }

  const uploadFileForProposer = async (e, field,isPreview = false) => {
    if (isPreview){
      handlePreview(e,field,"pr")
      setField(field)
      setEventState(e)
      return;
    }
    if(docNumberProposer?.[`${field}`]?.count > 6){
      errorToastr("Maximum 6 images can be Uploaded")
      return
    }
    if (isUploading) {
      return
    }
    let file = e?.target?.files[0]
    console.log(file, "file")
    if (!file) {
      return
    }

    if(!uploadFileValidations(file)) return;

    let formData = new FormData()
    if (e?.target?.files.length) {
      console.log(e.target.files, "dsskjjsf")
      setIsUploading(true)
      const file = e.target.files[0]
      formData.append("doc", file)
      formData.append("sub", true)
      let name = e.target.files?.[0]?.name || ""
      if(field === "_PHO_"){
        formData.append(
          "docPurpose", Date.now() + "-" +
          field + "." +
        name.split(".")[1]
        )
      }
      else {
        formData.append(
          "docPurpose", Date.now() + "-" +
          field + "0" + docNumberProposer?.[`${field}`]?.count + "." +
        name.split(".")[1]
        )
      }
      formData.append(
        "uploadDocPurpose", field.split("_")[1]
      )
      console.log(formData)

      try {
        let payload = {
          applicationNumber: journeyState.applicationNo,
          option: "PR"
        }
        const res = await uploadTempDocument(formData, payload) //journeyState.applicationNo
        if(res?.location == ''){
          errorToastr("File not supported")
        }
        let location = res.location
        let encryptedToken = aesEncryptData({ accessToken: accessToken })
        let base64EncodedToken = base64.encode(encryptedToken)
        // console.log("base64EncodedToken", base64EncodedToken)
        let newLocation = `${location}?auth=${base64EncodedToken}`
        // console.log("newLocation", newLocation)
        res.location = newLocation
        res.name = name
        console.log({ res })
        if(field === "_PHO_")
        {
          setResponseDocumentProposer({
            ...responseDocumentProposer,
            [field]: res,
           })
        }else {
          if (responseDocumentProposer?.[`${field}`].length === 1){
            if (documentPR?.[`${field}`].length > 1){
              let tempResposneDocument = []
              documentPR?.[`${field}`]?.map(doc => {
                tempResposneDocument.push({
                  location : doc.path,
                  fileName : doc.name,
                  msg : "",
                  name : doc.name
                })
              })
              setResponseDocumentProposer({
                ...responseDocumentProposer,
                [field]: [
                  ...tempResposneDocument,
                  res
                ],
              });
            }else{
              setResponseDocumentProposer({
                ...responseDocumentProposer,
                [field]: [
                  ...responseDocumentProposer[`${field}`],
                  res
                ],
              });
            }
          }else{
            setResponseDocumentProposer({
              ...responseDocumentProposer,
              [field]: [
                ...responseDocumentProposer[`${field}`],
                res
              ],
            });
          }
        }
        const singleDoc = ["_PHO_","_CNF_","_COC_","_DDI_","_ADD2_","_ADD2_","_BDI_"]
        if (!singleDoc.includes(field)){
          setDocNumberProposer({
            ...docNumberProposer,
            [field]: {
              count: docNumberProposer?.[`${field}`]?.count + 1
            },
          })
        }else{
          setDocNumberProposer({
            ...docNumberProposer,
            [field]: {
              count: 1
            },
          })
        }
        setIsUploading(false)
      } catch (error) {
        setIsUploading(false)
      }
    }
  }


  const uploadFileValidations=(file)=>{
    //check for file size
    if (file.size > 5242880) {
      errorToastr("Maximum file sixe allowed is 5 Mb")
      return false
    }

    //check for double extension
    let hasDoubleFormat = file.name?.split(".")?.length > 2
    if (hasDoubleFormat) {
      errorToastr("This file is not supported")
      return false
    }

    //Check for file format
    let fileFormat = file.name?.split(".")?.[1]
    console.log(fileFormat, "fileFormat")
    if (!fileFormat || !(["png","jpg", "jpeg", "tiff","tif","pdf"]).includes(fileFormat.toLowerCase())) {
      errorToastr("This file is not supported")
      return false
    }

    //Check for null type
    if (file.size < 10) {
      errorToastr("Invalid file")
      return false
    }

    //Check for mimetype
    if (!["image/x-png", "image/png", "application/pdf", "image/jpeg", "image/tiff"].includes(file.type)) {
      errorToastr("File not supported")
      return false
    }
    return true;
  }
  const uploadFileForSA = async (e, field,isPreview = false) => {
    if (isPreview){
      handlePreview(e,field,"sa")
      setField(field)
      setEventState(e)
      return;
    }
    if(docNumberjointLife?.[`${field}`]?.count > 6){
      errorToastr("Maximum 6 images can be Uploaded")
      return
    }
    if (isUploading) {
      return
    }
    let file = e?.target?.files[0]
    console.log(file, "file")
    if (!file) {
      return
    }

    //check for file size
    if (file.size > 5242880) {
      errorToastr("Maximum file sixe allowed is 5 Mb")
      return
    }

    //check for double extension
    let hasDoubleFormat = file.name?.split(".")?.length > 2
    if (hasDoubleFormat) {
      errorToastr("This file is not supported")
      return
    }

    //Check for file format
    let fileFormat = file.name?.split(".")?.[1]
    console.log(fileFormat, "fileFormat")
    if (!fileFormat || !(["png","jpg", "jpeg", "tiff","tif", "pdf"]).includes(fileFormat.toLowerCase())) {
      errorToastr("This file is not supported")
      return
    }

    //Check for null type
    if (file.size < 10) {
      errorToastr("Invalid file")
      return
    }

    //Check for mimetype
    if (!["image/x-png", "image/png", "application/pdf", "image/jpeg", "image/tiff"].includes(file.type)) {
      errorToastr("File not supported")
      return
    }

    let formData = new FormData()
    if (e?.target?.files.length) {
      console.log(e.target.files, "dsskjjsf")
      setIsUploading(true)
      const file = e.target.files[0]
      formData.append("doc", file)
      formData.append("sub", true)
      let name = e.target.files?.[0]?.name || ""
        formData.append(
          "docPurpose", Date.now() + "-" +
          field + "0" + docNumberjointLife?.[`${field}`]?.count + "." +
        name.split(".")[1]
        )
      formData.append(
        "uploadDocPurpose", field.split("_")[1]
      )
      console.log(formData)

      try {
        let payload = {
          applicationNumber: journeyState.applicationNo,
          option: "SA"
        }
        const res = await uploadTempDocument(formData, payload) //journeyState.applicationNo
        if(res?.location == ''){
          errorToastr("File not supported")
        }
        let location = res.location
        let encryptedToken = aesEncryptData({ accessToken: accessToken })
        let base64EncodedToken = base64.encode(encryptedToken)
        // console.log("base64EncodedToken", base64EncodedToken)
        let newLocation = `${location}?auth=${base64EncodedToken}`
        // console.log("newLocation", newLocation)
        res.location = newLocation
        res.name = name
        console.log({ res })
        if (documentforSA?.[`${field}`].length === 1){
          if (uploadedDocumentsSA?.[`${field}`].length > 1){
            let tempResposneDocument = []
            uploadedDocumentsSA?.[`${field}`]?.map(doc => {
              tempResposneDocument.push({
                location : doc.path,
                fileName : doc.name,
                msg : "",
                name : doc.name
              })
            })
            console.info(tempResposneDocument)
            setdocumentforSA({
              ...documentforSA,
              [field]: [
                ...tempResposneDocument,
                res
              ],
            });
          }else{
            setdocumentforSA({
              ...documentforSA,
              [field]: [
                ...documentforSA[`${field}`],
                res
              ],
            });
          }
        }else{
          setdocumentforSA({
            ...documentforSA,
            [field]: [
              ...documentforSA[`${field}`],
              res
            ],
          });
        }
        setDocNumberjointLife({
          ...docNumberjointLife,
          [field]: {
            count: docNumberjointLife?.[`${field}`]?.count + 1
          },
        })
        setIsUploading(false)
      } catch (error) {
        setIsUploading(false)
      }
    }
  }

  const isPdf = val => {
    if (!val) {
      return true
    }
    let format = val?.split(".")?.[val.split(".").length - 1]
    if (!format) {
      return true
    }
    return ["tiff", "pdf","tif"].includes(format.toLowerCase())
  }

  const handleNavigateFinarkein = async () => {
    console.log("finarkein")
    let data = {
      "id": journeyState.journeyId,
      "applicationNo": journeyState.applicationNo,
      "mobileNo": allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.communicationDetails?.contactDetails?.mobileNo : allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo,
      "journeyIdFromStrapi": allJourneyData?.journeyIdFromStrapi
    }
    const finarkeinRes = await finarkeinGenerateLink(data)
    console.log(finarkeinRes)
    if (finarkeinRes.data) {
      // window.location.replace(res.data.Perfios_URL)
      window.open(finarkeinRes.data.redirectUrl, "_self");
      // setIsUploading(false)
    }
    
  }

  const navigateToPerfiosUrl = async (e, field) => {
    var radios = document.getElementsByName("perfiosUploadDocument1")
    var formValid = false
    var i = 0
    while (!formValid && i < radios.length) {
      if (radios[i].checked) formValid = true
      i++
    }

    if (!formValid) {
      if (field) {
        setErrorState("")
        uploadFile(e, field)
      } else {
        setErrorState("Must check one option!")
      }
    } else {
      if (field) {
        setErrorState("")
        uploadFile(e, field)
      } else {
        try {
          setErrorState("")
          const res = await perfiosGenerateLink({
            applicationNo: journeyState.applicationNo,
            destination: bankingOptionSelect,
          })
          if (res.status) {
            // window.location.replace(res.data.Perfios_URL)
            window.open(res.data.Perfios_URL, "popup", "width=600,height=600")
            // setIsUploading(false)
          }
          console.log(res)
        } catch (err) {
          console.log(err)
        }
      }
      
    }
  }

  const changeBankingOption = $event => {
    setErrorState("")
    document.getElementById("file7").required = false
    setBankingOptionSelect($event.target.value)
  }

  const digiLockerRedirection = e => {
    let payloadData = {
      option: "LA",
      applicationNo: journeyState.applicationNo
    }
    let encryptData = CryptoJS.AES.encrypt(JSON.stringify(payloadData), process.env.ENCRYPT_KEY).toString();
    var encodedString = btoa(encryptData);
    let payload = {
      journeyId: journeyState.journeyIdFromStrapi
    }
    fetchDigilockerDetails(payload).then(async res => {
      console.log(res)
      let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
      if (`${process.env.DEVELOPMENT}` === "Y") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
      else if (`${process.env.DEVELOPMENT}` === "N") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/${productKey}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
    })
  }

  const digiLockerRedirectionPR = e => {
    let payloadData = {
      option: "PR",
      applicationNo: journeyState.applicationNo
    }
    let encryptData = CryptoJS.AES.encrypt(JSON.stringify(payloadData), process.env.ENCRYPT_KEY).toString();
    var encodedString = btoa(encryptData);
    let payload = {
      journeyId: journeyState.journeyIdFromStrapi
    }
    fetchDigilockerDetails(payload).then(async res => {
      console.log(res)
      let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
      if (`${process.env.DEVELOPMENT}` === "Y") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
      else if (`${process.env.DEVELOPMENT}` === "N") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/${productKey}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
    })
  }
  const digiLockerRedirectionSA = e => {
    let payloadData = {
      option: "SA",
      applicationNo: journeyState.applicationNo
    }
    let encryptData = CryptoJS.AES.encrypt(JSON.stringify(payloadData), process.env.ENCRYPT_KEY).toString();
    var encodedString = btoa(encryptData);
    let payload = {
      journeyId: journeyState.journeyIdFromStrapi
    }
    fetchDigilockerDetails(payload).then(async res => {
      console.log(res)
      let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
      if (`${process.env.DEVELOPMENT}` === "Y") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
      else if (`${process.env.DEVELOPMENT}` === "N") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/${productKey}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
    })
  }
  const handleSubmit = e => {
    e.preventDefault()
    setSubmitted(true);
    // console.log(submitted && !responseDocument["_ADP_"].fileName && (!addressProceedPermanent && disabledMessage))
    // console.log(submitted)
    console.log(responseDocument)
    // console.log(addressProceedPermanent)
    // console.log(disabledMessage)
    console.log(disable)
    console.log(addressProceedPermanent,)
    if(anurConfigChannels.includes(props?.channel?.toUpperCase()) && !vcOptionClicked){
      return;
    }
    // if(!VCOption){
    //   return;
    // } 
    // console.log((disable && !addressProceedPermanent)?false:(responseDocument._ADP_.fileName !== ''))
    // console.log((disable)?false:(responseDocument._IDP_.fileName !== ''))
    // console.log(((disable)?false:(responseDocument._AGP_.fileName !== '')))
    // console.log((responseDocument._PHO_.fileName == '' ) )
    // console.log((responseDocument["_SOW_"].fileName == ''))
    if ((responseDocument._PHO_.fileName == '' && uploadedDocuments?._PHO_?.name == '') ||
      (responseDocument._SOW_?.length < 2 && uploadedDocuments?._SOW_?.length < 2)) {
      console.log(1)
      return
    }
    if (allJourneyData?.basicDetails.channel === "A" && paymentMethod === "cheque") {
      if (responseDocument._COC_.fileName == '' && uploadedDocuments?._COC_?.name == '') {
        console.log(7)
        return
      }
    }
    if (allJourneyData?.basicDetails.channel === "A" && paymentMethod === "dd") {
      if (responseDocument._DDI_.fileName == '' && uploadedDocuments?._DDI_?.name == '') {
        console.log(7)
        return
      }
    }
      if (!disable) {
        if(!disableADP){
          if (!addressProceedPermanent && responseDocument._CAP_.fileName == '' && uploadedDocuments?._CAP_?.name == '' && responseDocument._PAP_.fileName == '' && uploadedDocuments._PAP_.name == '') {
            console.log(2)
            return
          }
        }
        if(!disableIDP){
          if (responseDocument._IDP_?.length < 2 && uploadedDocuments?._IDP_?.length < 2) {
            console.log(3)
            return
          }
        }
        if(!disableAGP){
          if (responseDocument._AGP_?.length < 2 && uploadedDocuments?._AGP_?.length < 2) {
            console.log(4)
            return
          }
        }
        if(!disableADP){
          if (responseDocument._CAP_?.length < 2 && uploadedDocuments?._CAP_?.length < 2 && responseDocument._PAP_?.length < 2  && uploadedDocuments._PAP_?.length < 2) {
            console.log(5)
            return
          }
        }
      }
      if(allJourneyData?.lifeAssuredDetails?.communicationDetails?.sameAsCurrentAddress === "N" ){
        if(!disablePermanentAddress){
         if (responseDocument._PAP_?.length < 2 && uploadedDocuments._PAP_?.length < 2 && responseDocument._CAP_?.length < 2 && uploadedDocuments._CAP_?.length < 2) {
           console.log(5)
           return
           }
         }
        }
      if (!disableAadhar && !disableAadhaarDL) {
        if (responseDocument._UID_?.length < 2 && uploadedDocuments?._UID_?.length < 2) {
          console.log(5)
          return
        }
      }
    if (allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N") {
      if ((responseDocumentProposer._PHO_.fileName == '' && documentPR._PHO_.name == ''))
      {
        console.log(51)
        return
      }
      if (!disableProposer) {
        if(!disableADPPR){
          if (responseDocumentProposer._CAP_.length < 2 && documentPR?._CAP_?.length < 2 && responseDocumentProposer._PAP_?.length < 2 && documentPR._PAP_?.length < 2) {
            console.log(6)
            return
          }
        }
        if(!disableIDPPR){
          if (responseDocumentProposer._IDP_?.length < 2 && documentPR?._IDP_?.length < 2) {
            console.log(3)
            return
          }
        }
      }
      if(allJourneyData?.proposerDetails?.communicationDetails?.sameAsCurrentAddress === "N" ){
        if(!disableProposerPermanentAddress){
         if (responseDocumentProposer._PAP_?.length < 2 && documentPR._PAP_?.length < 2 && responseDocumentProposer._CAP_?.length < 2 && documentPR._CAP_?.length < 2) {
           console.log(5)
           return
           }
         }
        }
    }

    if (allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02") {
        if(!disableIDPSA){
          if (documentforSA._IDP_?.length < 2 && uploadedDocumentsSA._IDP_?.length < 2) {
            console.log(11)
            return
          }
        }
        if(!disableADPSA){
          if (documentforSA._ADP_?.length < 2 && uploadedDocumentsSA._ADP_?.length < 2) {
            console.log(12)
            return
          }
        }
    }
    console.log(22222)
    // getS3FilenetUpload(journeyState.applicationNo).then(res => {
    //   console.log(res.data)
    // })
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex + 1,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      }
    }
    moveTempDocumentsToPermanentBucket({applicationNumber : journeyState?.applicationNo})
    .then(res => {
      saveApplication(sendPayload).then(res => {
        props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
        setJourneyState(prev => {
          return {
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            lastPageCode: props.pageId,
            lastSectionCode:
              props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      })
    })
    .catch(err => {
      errorToastr("Something went wrong, please try again!")
      console.log(err)
    })
  }

  const documentDownload = (ev, docName) => {
    ev.preventDefault()
    let url = retreiveUploadedDocumentsData?.fetchedDocuments.forEach((element, index)=>{
      if(element[index]["docName"] === docName){
        return element[index]["docPath"]
      }
    })
    // let url = link
    let encryptedToken = aesEncryptData({ accessToken: accessToken })
    let base64EncodedToken = base64.encode(encryptedToken)
    let newUrl = `${url}?auth=${base64EncodedToken}`
    return newUrl
  }

  const downloadFile = (e, docLocation) => {
    e.preventDefault()
    let url = `${process.env.GATASBY_API_URL}/get-uploaded-file/${docLocation}`
      // let url = link
      let encryptedToken = aesEncryptData({ accessToken: accessToken })
      let base64EncodedToken = base64.encode(encryptedToken)
      let newUrl = `${url}?auth=${base64EncodedToken}`
      window.open(newUrl,"_self")
      return newUrl
}

const printFile = async (e, docLocation) => {
    e.preventDefault()
    let payload = {
        "proposerFormLink": docLocation,
        "applicationNumber": journeyState.applicationNo
    }
    let data = await s3DownloadDocuments(payload)
    let base64Data = data?.data

    const newWindow = window.open("", "", "width=100, height=100")
    if (newWindow) {
      const document = newWindow.document.open()
      document.close()
      newWindow.moveTo(0, 0)
      newWindow.resizeTo(window.screen.width, window.screen.height)
      const contentType = "application/pdf"
      const b64Data = base64Data
      const blob = b64toBlob(b64Data, contentType)
      const blobUrl = URL.createObjectURL(blob)
      document.write(`<iframe id="pdfDocument"
      src="${blobUrl}" 
      width="100%"
      height="100%"
      frameBorder="0" ></iframe>`)
      const docs = document.getElementById("pdfDocument")
      setTimeout(() => {
        docs.contentWindow.print()
      }, 1000)
    }

    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || ""
        sliceSize = sliceSize || 512
  
        var byteCharacters = atob(b64Data)
        var byteArrays = []
  
        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize)
  
          var byteNumbers = new Array(slice.length)
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
          }
  
          var byteArray = new Uint8Array(byteNumbers)
  
          byteArrays.push(byteArray)
        }
  
        var blob = new Blob(byteArrays, { type: contentType })
        return blob
      }
}

function getKeyByValue(value, object) {
  return object.find(key => key.description == value)
}

const handleChange = (value, object) => {
  // e.preventDefault()
  setSelectedOption(value.value)

  let selectedValue =  object.find(key => key.description == value.value)
  setSelectedOptionData(selectedValue)

  retreiveUploadedDocumentsFunction()

}

function retreiveUploadedDocumentsFunction(){
  retreiveUploadedDocuments({"applicationNumber":journeyState.applicationNo})
  .then(res => {
    console.log(res);
    setRetreiveUploadedDocuments(res?.data)
    let options = res?.data?.map((el) => {
      console.log(el);
      return el.description 
    })
    options = Object.entries(options)?.map(([key, val]) => ({
              value: val,
              label: val,
            }))
    console.log(options);
    setDocOptions(options)
    console.log(docOptions);
  })
  .catch(err => {
    console.log(err);
  })
}

function openModal(data,type) {
  const imageSrc = data.src
  var modal = document.getElementById("imageModal");
  var modalImage = document.getElementById("modalImage");
  modal.style.display = "block";
  modalImage.src = imageSrc;
  modalImage.setAttribute('data-modal-filename',data.getAttribute('data-filename'))
  modalImage.setAttribute('data-modal-doctype',data.getAttribute('data-doctype'))
  const heading = modal.querySelector("#image-preview-after-upload")
  const ele = document.getElementById("previewUpload2")
  ele.setAttribute("data-type",data.getAttribute("data-type") || "la")
  if (type === "pdf"){
    heading.innerText = data.getAttribute('data-name')
    heading.style.marginRight = "50px"
  }else{
    heading.innerText = "Image Preview"
  }
}

function closeModal() {
  var modal = document.getElementById("imageModal");

  // Check if the modal element is found
  if (modal) {
    modal.style.display = "none";
  }
}

function removeApplicationNo(filename){
  const fileNameArray = filename?.split('/')
  fileNameArray?.shift()
  let fileNameWithoutApplicationNo = fileNameArray?.join('/')
  return fileNameWithoutApplicationNo;
}

async function deleteFile(e,type = "la") {
  const deleteButton = e.target
  const previewImageContainer = deleteButton?.closest(".previewImageContainer")
  if (previewImageContainer){
    const image = previewImageContainer.querySelector(".preview-img")
    if (image){
      const filename = image.getAttribute('data-modal-filename')
      const doctype = image.getAttribute('data-modal-doctype')
      if (journeyState.applicationNo){
        const keyName = filename
        let res
        try {
          res = await deleteTempDocument({keyName})
        }catch(err){
          errorToastr('Could not delete file')
          return
        }
        try{
          const singleDoc = ["PHO","CNF","COC","DDI","ADD2","ADD2","BDI"]
          successToastr(res?.msg)
          closeModal()
          if (!singleDoc.includes(doctype)){
            if (type === "la"){
              const tempResposneDocument = deepCopy(responseDocument)
              const filteredResponse = tempResposneDocument[`_${doctype}_`]?.filter(tempDocument => tempDocument?.fileName !== '/' + removeApplicationNo(filename))
              tempResposneDocument[`_${doctype}_`] = filteredResponse
              setResponseDocument(deepCopy(tempResposneDocument))
              const tempUploadDocuments = deepCopy(uploadedDocuments)
              const uploadFilteredResponse = tempUploadDocuments[`_${doctype}_`]?.filter(tempDocument => tempDocument?.location !== filename)
              tempUploadDocuments[`_${doctype}_`] = uploadFilteredResponse
              setUploadedDocuments(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumber)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumber(tempDocNumberCount)
            }else if (type === "pr"){
              const tempResposneDocument = deepCopy(responseDocumentProposer)
              const filteredResponse = tempResposneDocument[`_${doctype}_`]?.filter(tempDocument => tempDocument?.fileName !== '/' + removeApplicationNo(filename))
              tempResposneDocument[`_${doctype}_`] = filteredResponse
              setResponseDocumentProposer(deepCopy(tempResposneDocument))
              const tempUploadDocuments = deepCopy(documentPR)
              const uploadFilteredResponse = tempUploadDocuments[`_${doctype}_`]?.filter(tempDocument => tempDocument?.location !== filename)
              tempUploadDocuments[`_${doctype}_`] = uploadFilteredResponse
              setdocumentPR(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumberProposer)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumberProposer(tempDocNumberCount)
            }else if (type === "sa"){
              const tempResposneDocument = deepCopy(documentforSA)
              const filteredResponse = tempResposneDocument[`_${doctype}_`]?.filter(tempDocument => tempDocument?.fileName !== '/' + removeApplicationNo(filename))
              tempResposneDocument[`_${doctype}_`] = filteredResponse
              setdocumentforSA(deepCopy(tempResposneDocument))
              const tempUploadDocuments = deepCopy(uploadedDocumentsSA)
              const uploadFilteredResponse = tempUploadDocuments[`_${doctype}_`]?.filter(tempDocument => tempDocument?.location !== filename)
              tempUploadDocuments[`_${doctype}_`] = uploadFilteredResponse
              setUploadedDocumentsSA(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumberjointLife)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumberjointLife(tempDocNumberCount)
            }
          }else{
            if (type === "la"){
              const tempResponseDocuments = deepCopy(responseDocument)
              tempResponseDocuments[`_${doctype}_`] = {
                location: "",
                fileName: "",
                msg: "",
              }
              setResponseDocument(deepCopy(tempResponseDocuments))
              const tempUploadDocuments = deepCopy(uploadedDocuments)
              tempUploadDocuments[`_${doctype}_`] = {
                path: "",
                name: "",
                location : "",
                msg: "",
              }
              setUploadedDocuments(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumber)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumber(tempDocNumberCount)
            }else if (type === "pr"){
              const tempResponseDocuments = deepCopy(responseDocumentProposer)
              tempResponseDocuments[`_${doctype}_`] = {
                location: "",
                fileName: "",
                msg: "",
              }
              setResponseDocumentProposer(deepCopy(tempResponseDocuments))
              const tempUploadDocuments = deepCopy(documentPR)
              tempUploadDocuments[`_${doctype}_`] = {
                filename: "",
                name: "",
                location : "",
                msg: "",
              }
              setdocumentPR(deepCopy(tempUploadDocuments))
              setdocumentPR(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumberProposer)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumberProposer(tempDocNumberCount)
            }else if (type === "sa"){
              const tempResponseDocuments = deepCopy(documentforSA)
              tempResponseDocuments[`_${doctype}_`] = {
                location: "",
                fileName: "",
                msg: "",
              }
              setdocumentforSA(deepCopy(tempResponseDocuments))
              const tempUploadDocuments = deepCopy(uploadedDocumentsSA)
              tempUploadDocuments[`_${doctype}_`] = {
                filename: "",
                name: "",
                location : "",
                msg: "",
              }
              setUploadedDocumentsSA(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumberjointLife)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumberjointLife(tempDocNumberCount)
            }
          }
        }catch(err){
          console.info(err)
        }
      }
    }
  }
}

  const generateVCLink = async (e,linkOnly) => {
    e.preventDefault()
    if (vcTimerActive) {
      errorToastr(`Please wait ${vcTimeLeft} second${vcTimeLeft !== 1 ? "s" : ""} before trying again.`);
      return;
    }
    if(!linkOnly && !vcIdProof){// mandatory when proceed now
      errorToastr(`Please upload a valid ID proof first`);
      return;
    }
    setVCTimerActive(true);
     try {
      // For "Proceed Later", send null instead of actual file
      let formData = vcIdProof;
      if (linkOnly) {
        if (!formData?.has("image")) {
          const defaultWhiteImage = new FormData();
          /// Create a 1x1 white pixel image
          const whiteImageBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
          // Convert base64 to blob
          const byteString = atob(whiteImageBase64.split(',')[1]);
          const mimeString = whiteImageBase64.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([ab], { type: mimeString });
          // Create FormData with white image
          defaultWhiteImage.append("image", blob, "default_white.png");
          formData = defaultWhiteImage;
          console.log("Image is attached.", formData);
        }
      }


      const data = await generateAnurVCLink({ journeyRef: journeyState.journeyId }, formData);
      if (!linkOnly && data.data?.link) {
        window.open(data.data?.link, "_blank");
      }

      successToastr("VC verification link has been sent to your registered email and mobile number");
      setVCOptionClicked(true);
    } catch (error) {
      setVCTimerActive(false); // Cancel timer immediately on error
      console.error(error)
      errorToastr(error?.response?.data?.message || error.message)
    }
  }
  return (
    <>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
          .choose-file-design{
              cursor:pointer;
          }

          .btn-disable{
              opacity:.5;
              pointer-events:none
          }
          .but-center-upload {
            clear: both;
            margin: 0px;
            padding: 14px;
            display: inline-block;
            width: 100%;
            text-align: center;
        }
          .elephant{
            display:flex;
            background:#dfdfdf;
            border:1px solid #ccc; 
            border-radius:4px;
            padding-right:.5rem;
            padding-bottom:.5rem;
          }

          .elephant img{
            position:relative;
            top:-2.5rem;
            left:-2.5rem;
          }

          .align-perfios-button{
            display:flex;
            justify-content:space-between;
          }
          .upload-img{
            display: flex;
            justify-content: space-between;
          }
          .upload-img img{
            width: 4rem;
            height: 4rem;
          }
                    .modal {
            display:none
            position: fixed;
            z-index: 1; 
            padding-top: 100px; 
            left: 0;
            top: 0;
            width: 100%; 
            height: 100%; 
            overflow: auto; 
            background-color: 
            background-color: rgba(0,0,0,0.9);
          }
          /* Modal Content */
          .modal-content {
            margin: auto;
            display: block;
            width: 100%;
            max-width: 700px;
          }
          /* Close button */
          .close {
            position: absolute;
            top: 15px;
            right: 35px;
            color: #f1f1f1;
            font-size: 40px;
            font-weight: bold;
            transition: 0.3s;
          }
          .close:hover,
          .close:focus {
            color: #bbb;
            text-decoration: none;
            cursor: pointer;
          }
          .anur{
            border:1px solid #cfcfcf;
            border-radius:10px;
            margin-top:45px !important;
          }
          @media (max-width: 600px){
          .anur{
            flex-direction:column;
          }
          .anur div{
              flex-direction: column;
              align-items: center;
              justify-content: center;
          }
          .anur > div > div{
              max-width:100% !important;
              width:100% !important;
          }
          .anur-button{
                width: 70%;
                padding: 10px !important;
          }

          }
        `}
      </style>

      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ">
              <div className="iselect-box-design">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head ckyc-w">
                    <h1 className="iselect-heading">Upload Documents</h1>
                  </div>
                  <div className="app-quatation nri-mt-space hidden-desktop-screen">
                    <div className="application-design-number">
                      Application Number: {journeyState.applicationNo}
                    </div>
                  </div>
                </div>
                <form id="uploaddocument-form">
                  {
                    anurConfigChannels.includes(props?.channel?.toUpperCase()) &&
                    <>
                    <div className="col-md-12 flex-column my-4 p-3 anur">
                      <p className="fs-5 p-2 mb-0">
                        Video verification
                      </p>
                        <div className="col-md-12 d-flex gap-2">
                          <div className="col-md-12 my-3 d-flex gap-2" style={{maxWidth:"fit-content"}}>
                            <div className="justify-content-center d-flex align-items-center cen py-1 px-2 mx-0">
                              <label className="choose-file-design" style={{ marginLeft: "10px" }}>
                                Upload ID Proof
                                <input
                                  type="file" svg
                                  accept="image/x-png,image/png,image/jpeg,image/tiff,image/bmp,image/webp,application/pdf"
                                  onChange={handleVCIdProofChange}
                                  style={{ display: "none" }}
                                />
                              </label>
                            </div>
                            {vcIdProof && (
                              <div style={{ marginTop: "10px" }} className="d-flex align-items-center gap-2 justify-content-center flex-column mw-25">
                                {/* Optionally show preview */}
                                <img src={withPrefix("/images/upload2.png")} alt="ID Proof Preview" style={{ maxWidth: "70px", marginLeft: "10px" }} />
                                <span style={{ color: "green" }} className="text-truncate mw-100 " title={`${vcIdProofName}`}>{vcIdProofName}</span>
                              </div>
                            )}
                          </div>
                          <div className="d-flex flex-column gap-4 justify-content-center align-items-center my-auto ml-auto" style={{maxWidth:"fit-content"}}>
                            <div className="previous-btn cen py-2 px-5 mx-0 anur-button">
                              <button
                                name="start"
                                style={{ backgroundColor: "transparent", border: "none", borderRadius: "10px", color: "#fff" }}
                                onClick={(e) => {  generateVCLink(e,false) }}
                              >
                                Proceed Now
                              </button>
                            </div>
                            <div className="previous-btn cen py-2 px-5 mx-0 anur-button">
                              <button

                                name="share"
                                style={{ backgroundColor: "transparent", border: "none", borderRadius: "10px", color: "#fff" }}
                                onClick={(e) => {  generateVCLink(e,true) }}
                              >
                                Proceed Later
                              </button>
                            </div>
                          </div>
                        </div>
                    </div>
                    {submitted && !vcOptionClicked && <p className="input-error">Please complete Video verification</p>}
                    </>

                  }
                  <div className="col-md-12">
                    <div className="pension18 row">
                      <div className="col-md-6">
                        <div className="upload-list-design">
                         <p className="first-up-content">
                            Aadhaar Card of life assured <span>(Upload front and back side of Aadhaar)</span>
                         </p> 
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label

                                  className="choose-file-design"
                                  onKeyPress={(event) => handleFileEnter(event, 'file2')} tabIndex="0"
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file2"
                                    name="file2"
                                    multiple
                                    onInput={e => uploadFile(e, "_UID_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable}
                                    disabled={disableAadhar || disableAadhaarDL}
                                  />
                                </label>
                                {!(disabledMessageAadhar || disableAadhaarMessage) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery1 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                {disabledMessageAadhar || disableAadhaarMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img1">
                              {responseDocument?._UID_?.length > 1 ? responseDocument?._UID_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"UID"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload1.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._UID_?.length > 1 ? uploadedDocuments?._UID_?.slice(1).map(doc => {
               
                                  
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"UID"}
                                    data-name={doc?.name}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload1.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload1.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && responseDocument?._UID_?.length < 2 && uploadedDocuments?._UID_?.length < 2  && !disableAadhar && <p className="input-error" >Please upload Aadhaar Card</p>}
                            </div>
                            <div className="errormsg1 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p className="first-up-content">
                            Photograph of Life Assured{" "}
                            <span>
                              {" "}
                              Latest within 3 month/ Upload full size Photograph
                            </span>
                          </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}>
                                <label className="choose-file-design">
                                  Upload
                                  <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    multiple
                                    onInput={e => uploadFile(e, "_PHO_",true)}
                                    onKeyPress={(event) => handleFileEnter(event, 'file1')} tabIndex="0"
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  // required
                                  />
                                </label>
                                                                <span></span>
                              </div>
                              <div className="gallery"> </div>
                              <div className="upload-img icon-img">
                                {" "}
                                <img
                                data-filename = {responseDocument._PHO_.fileName ? (journeyState.applicationNo +  responseDocument._PHO_.fileName) : uploadedDocuments?._PHO_?.location}
                                className="upload-document-img"
                                data-doctype = {"PHO"}
                                doc-name = {responseDocument._PHO_.name || uploadedDocuments?._PHO_?.name || "Uploaded file"}
                                  src={
                                     responseDocument._PHO_.fileName
                                      ? isPdf(responseDocument._PHO_.fileName)
                                        ? pdfIcon
                                        : responseDocument._PHO_.location
                                      : uploadedDocuments?._PHO_?.name
                                      ? isPdf(uploadedDocuments._PHO_.name)
                                        ? pdfIcon
                                        : uploadedDocuments._PHO_.path
                                        : withPrefix("/images/upload1.png")
                                  }
                                  aria-hidden="true"
                                  onClick={(e) =>  {
                                    if (responseDocument._PHO_.fileName || uploadedDocuments?._PHO_?.name){
                                     if (isPdf(responseDocument._PHO_.fileName || uploadedDocuments?._PHO_?.name)){
                                       openModal(e.target,"pdf")
                                     }else{
                                       openModal(e.target,"img")
                                     }
                                    }
                                 }}
                                />{" "}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {
                                submitted && !uploadedDocuments?._PHO_.name && !responseDocument._PHO_.fileName && <p className="input-error" >Please upload Photograph of Life Assured</p>
                              }
                            </div>
                            <div className="errormsg clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                       
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>ID Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label

                                  className="choose-file-design"
                                  onKeyPress={(event) => handleFileEnter(event, 'file2')} tabIndex="0"
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file2"
                                    name="file2"
                                    multiple
                                    onInput={e => uploadFile(e, "_IDP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable}
                                    disabled={disable || disableIDP}
                                  />
                                </label>
                                {!(disableIDPmessage || disabledMessage) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery1 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {disableIDP ? disableIDPmessage :disabledMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img1">
                              {responseDocument?._IDP_?.length > 1 ? responseDocument?._IDP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"IDP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload2.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._IDP_?.length > 1 ? uploadedDocuments?._IDP_?.slice(1).map(doc => {
                                  
                                  
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"IDP"}
                                    data-name={doc?.name}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload2.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload2.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                             {submitted && uploadedDocuments?._IDP_?.length < 2 && responseDocument?._IDP_?.length < 2 && !disable && <p className="input-error" >Please upload ID Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg1 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 ">
                        <div className="upload-list-design">
                          <p>Income Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file3')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file3"
                                    name="file2"
                                    multiple
                                    onInput={e => uploadFile(e, "_SOW_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  // required
                                  />
                                </label>
                                <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />
                              </div>
                              <div className="gallery2 upload-img"> </div>
                              <div className="upload-img icon-img2">
                              {responseDocument?._SOW_?.length > 1 ? responseDocument?._SOW_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"SOW"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload3.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._SOW_?.length > 1 ? uploadedDocuments?._SOW_?.slice(1).map(doc => {
                           
                                  
                                  return (
                                    <img
                                    data-filename = {doc.location}
                                    data-doctype = {"SOW"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload3.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload3.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && uploadedDocuments?._SOW_?.length < 2 && responseDocument?._SOW_?.length < 2 && <p className="input-error">Please upload Income Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg2 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Current Address Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file4')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file4"
                                    name="file3"
                                    multiple
                                    onInput={e => uploadFile(e, "_CAP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable || addressProceedPermanent}
                                    disabled={disableADP || disable && !addressProceedPermanent}
                                  />
                                </label>
                                {!(disableADPmessage || (!addressProceedPermanent && disabledMessage)) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery3 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {disableADP ? disableADPmessage :!addressProceedPermanent && disabledMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img3">
                              {responseDocument?._CAP_?.length > 1 ? responseDocument?._CAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"CAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._CAP_?.length > 1 ? uploadedDocuments?._CAP_?.slice(1).map(doc => {
                            
                                  
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"CAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload4.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && uploadedDocuments?._PAP_?.length < 2 && uploadedDocuments?._CAP_?.length < 2 && responseDocument?._CAP_?.length < 2 && responseDocument?._PAP_?.length < 2 && !(!addressProceedPermanent && disabledMessage) && <p className="input-error">Please upload Current Address Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg3 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      { allJourneyData?.lifeAssuredDetails?.communicationDetails?.sameAsCurrentAddress === "N" &&
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Permanent Address Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file4')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file4"
                                    name="file3"
                                    multiple
                                    onInput={e => uploadFile(e, "_PAP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable || addressProceedPermanent}
                                    disabled={disablePermanentAddress}
                                  />
                                </label>
                                {!permanentAddressDisableMessage && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery3 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {permanentAddressDisableMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img3">
                              {responseDocument?._PAP_?.length > 1 ? responseDocument?._PAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"PAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._PAP_?.length > 1 ? uploadedDocuments?._PAP_?.slice(1).map(doc => {
                          
                                  
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"PAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload4.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && uploadedDocuments?._PAP_?.length < 2 && uploadedDocuments?._CAP_?.length < 2 && responseDocument?._CAP_?.length < 2 && responseDocument?._PAP_?.length < 2 && !(disablePermanentAddress) && <p className="input-error">Please upload Permanent Address Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg3 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                       }
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Age Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file5')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file5"
                                    name="file4"
                                    multiple
                                    onInput={e => uploadFile(e, "_AGP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable}
                                    disabled={disable || disableAGP}
                                  />
                                </label>
                                {!(disableAGPmessage || disabledMessage) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery4 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {disableAGP ? disableAGPmessage : disabledMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img4">
                              {responseDocument?._AGP_?.length > 1 ? responseDocument?._AGP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"AGP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._AGP_?.length > 1 ? uploadedDocuments?._AGP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"AGP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload5.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && uploadedDocuments?._AGP_?.length < 2 && responseDocument._AGP_.length < 2 && !disable && <p className="input-error">Please upload Age Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg4 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" &&
                        <div className="col-md-6">
                          <div className="upload-list-design">
                            <p>ID Proof of Proposer </p>
                            <div className="upload-list">
                              <div>
                                <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                  <label

                                    className="choose-file-design"
                                    onKeyPress={(event) => handleFileEnter(event, 'file2')} tabIndex="0"
                                  >
                                    {" "}
                                    Upload
                                    <input
                                      type="file"
                                      id="file2"
                                      name="file2"
                                      multiple
                                      onInput={e => uploadFileForProposer(e, "_IDP_",true)}
                                      accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                      // required
                                      // required={!disable}
                                      disabled={disableIDPPR || disableProposer}
                                    />
                                  </label>
                                  {!(disableIDPPRmessage || disabledMessageProposer) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                                </div>
                                <div className="gallery1 upload-img"> </div>
                                <div style={{ display: "flex", float: "left" }}>
                                  <span
                                    style={{
                                      color: "orange",
                                      fontSize: "20px",
                                      marginLeft: "20px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {disableIDPPR ? disableIDPPRmessage :disabledMessageProposer}
                                  </span>
                                </div>
                                <div className="upload-img icon-img1">
                                {responseDocumentProposer?._IDP_?.length > 1 ? responseDocumentProposer?._IDP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"IDP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : documentPR?._IDP_?.length > 1 ? documentPR?._IDP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"IDP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload5.png")}
                              />}
                                </div>
                              </div>
                              <div className="file-inp-err" >
                                {submitted && documentPR?._IDP_?.length < 2 && responseDocumentProposer._IDP_.length < 2 && !disableProposer && <p className="input-error" >Please upload ID Proof of Proposer</p>}
                              </div>
                              <div className="errormsg1 clearfixerror"></div>
                            </div>
                          </div>
                        </div>
                      }
                      {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" &&
                        <div className="col-md-6">
                          <div className="upload-list-design">
                            <p>Current Address Proof of Proposer </p>
                            <div className="upload-list">
                              <div>
                                <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                  <label
                                    disabled={isUploading}
                                    className="choose-file-design"
                                    tabIndex="0"
                                    onKeyPress={(event) => handleFileEnter(event, 'file4')}
                                  >
                                    {" "}
                                    Upload
                                    <input
                                      type="file"
                                      id="file4"
                                      name="file3"
                                      multiple
                                      onInput={e => uploadFileForProposer(e, "_CAP_",true)}
                                      accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                      // required
                                      // required={!disable || addressProceedPermanent}
                                      disabled={disableADPPR || disableProposer}
                                    />
                                  </label>
                                  {!(disableADPPRmessage || disabledMessageProposer) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                                </div>
                                <div className="gallery3 upload-img"> </div>
                                <div style={{ display: "flex", float: "left" }}>
                                  <span
                                    style={{
                                      color: "orange",
                                      fontSize: "20px",
                                      marginLeft: "20px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {disableADPPR ? disableADPPRmessage :  disabledMessageProposer}
                                  </span>
                                </div>
                                <div className="upload-img icon-img3">
                                {responseDocumentProposer?._CAP_?.length > 1 ? responseDocumentProposer?._CAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"CAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : documentPR?._CAP_?.length > 1 ? documentPR?._CAP_?.slice(1).map(doc => {
                                  
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"CAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload4.png")}
                              />}
                                </div>
                              </div>
                              <div className="file-inp-err" >
                                {submitted && documentPR?._PAP_?.length < 2 && documentPR?._CAP_?.length < 2 && responseDocumentProposer?._CAP_?.length < 2 && responseDocumentProposer?._PAP_?.length < 2 && !(disabledMessageProposer) && <p className="input-error">Please upload  current address proof of proposer</p>}
                              </div>
                              <div className="errormsg3 clearfixerror"></div>
                            </div>
                          </div>
                        </div>
                      }
                      { allJourneyData?.proposerDetails?.communicationDetails?.sameAsCurrentAddress === "N" && 
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Permanent address proof of Proposer </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file4')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file4"
                                    name="file3"
                                    multiple
                                    onInput={e => uploadFileForProposer(e, "_PAP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    disabled={disableProposerPermanentAddress}
                                  />
                                </label>
                                {!permanentProposerAddressDisableMessage && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery3 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {permanentProposerAddressDisableMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img3">
                              {responseDocumentProposer?._PAP_?.length > 1 ? responseDocumentProposer?._PAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"PAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : documentPR?._PAP_?.length > 1 ? documentPR?._PAP_?.slice(1).map(doc => {
                                 
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"PAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload4.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && documentPR?._PAP_?.length < 2 && documentPR?._CAP_?.length < 2 && responseDocumentProposer?._CAP_?.length < 2 && responseDocumentProposer?._PAP_?.length < 2 && !(disableProposerPermanentAddress) && <p className="input-error">Please upload permanent address proof of proposer</p>}
                            </div>
                            <div className="errormsg3 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      }
                      { allJourneyData?.journeyType?.toLowerCase() === "canarapos" && <div className="col-md-6">
                          <div className="upload-list-design">
                          <p>Consent Form</p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file6')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file6"
                                    name="file5"
                                    multiple
                                    onInput={e => uploadFile(e, "_CNF_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  />
                                </label>
                              </div>
                              <div className="gallery5 upload-img"> </div>
                              <div className="upload-img icon-img5">
                                {" "}
                                <img
                                data-filename = {responseDocument._CNF_.fileName ? (journeyState.applicationNo +  responseDocument._CNF_.fileName) : uploadedDocuments?._CNF_?.location}
                                className="upload-document-img"
                                data-doctype = {"CNF"}
                                data-name = {responseDocument._CNF_.name || uploadedDocuments?._CNF_?.name || "Uploaded file"}
                                  src={
                                      responseDocument._CNF_.fileName
                                      ? isPdf(responseDocument._CNF_.fileName)
                                        ? pdfIcon
                                        : responseDocument._CNF_.location
                                      : uploadedDocuments?._CNF_?.name
                                      ? isPdf(uploadedDocuments._CNF_.name)
                                        ? pdfIcon
                                        : uploadedDocuments._CNF_.path
                                        : withPrefix("/images/upload51.png")
                                  }
                                  aria-hidden="true"
                                  onClick={(e) =>  {
                                    if (responseDocument._CNF_.fileName || uploadedDocuments?._CNF_?.name){
                                     if (isPdf(responseDocument._CNF_.fileName || uploadedDocuments?._CNF_?.name)){
                                       openModal(e.target,"pdf")
                                     }else{
                                       openModal(e.target,"img")
                                     }
                                    }
                                 }}
                                />{" "}
                              </div>
                            </div>
                            <div className="errormsg5 clearfixerror"></div>
                          </div>
                        </div>
                      </div>}
                      {(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" && (journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney")) &&
                        <div className="col-md-6">
                          <div className="upload-list-design">
                            <p>ID Proof of Secondary Annutant </p>
                            <div className="upload-list">
                              <div>
                                <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                  <label

                                    className="choose-file-design"
                                    onKeyPress={(event) => handleFileEnter(event, 'file11')} tabIndex="0"
                                  >
                                    {" "}
                                    Upload
                                    <input
                                      type="file"
                                      id="file11"
                                      name="file11"
                                      multiple
                                      onInput={e => uploadFileForSA(e, "_IDP_",true)}
                                      accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable}
                                    disabled={disableIDPSA}
                                    />
                                  </label>
                                 {!disableIDPSAmessage && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                                </div>
                                <div className="gallery1 upload-img"> </div>
                                <div style={{ display: "flex", float: "left" }}>
                                  <span
                                    style={{
                                      color: "orange",
                                      fontSize: "20px",
                                      marginLeft: "20px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {disableIDPSAmessage}
                                  </span>
                                </div>
                                <div className="upload-img icon-img3">
                                {documentforSA?._IDP_?.length > 1 ? documentforSA?._IDP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"IDP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="sa"
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload2.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocumentsSA?._IDP_?.length > 1 ? uploadedDocumentsSA?._IDP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"IDP"}
                                    data-name={doc?.name}
                                    data-type="sa"
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload2.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload2.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                             {submitted && documentforSA?._IDP_?.length < 2 && uploadedDocumentsSA?._IDP_?.length < 2 && !disable && <p className="input-error" >Please upload ID proof of secondary Annutant</p>}
                              </div>
                              <div className="errormsg1 clearfixerror"></div>
                            </div>
                          </div>
                        </div>
                      }
                      {(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" && (journeyState.journeyIdFromStrapi === "pension4LifeJourney" || journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney")) &&
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Address Proof of Secondary Annuitant </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label

                                  className="choose-file-design"
                                  onKeyPress={(event) => handleFileEnter(event, 'file12')} tabIndex="0"
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file12"
                                    name="file12"
                                    multiple
                                    onInput={e => uploadFileForSA(e, "_ADP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  // required
                                  // required={!disable}
                                  disabled={disableADPSA}
                                  />
                                </label>
                                {!disableADPSAmessage && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery1 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {disableADPSAmessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img3">
                              {documentforSA?._ADP_?.length > 1 ? documentforSA?._ADP_?.slice(1).map(doc => {
                                return (
                                  <img
                                  data-filename = {journeyState.applicationNo +  doc.fileName}
                                  className="upload-document-img"
                                  data-doctype = {"ADP"}
                                  data-name = {doc?.name || "Uploaded file"}
                                  data-type="sa"
                                  src={
                                    doc?.fileName
                                      ? isPdf(doc?.fileName)
                                        ? pdfIcon
                                        : doc.location
                                      : withPrefix("/images/upload2.png")
                                  }
                                  aria-hidden="true"
                                  onClick={(e) =>  {
                                    if (doc?.fileName){
                                     if (isPdf(doc.fileName)){
                                       openModal(e.target,"pdf")
                                     }else{
                                       openModal(e.target,"img")
                                     }
                                    }
                                 }}
                                />
                                )
                                }) : uploadedDocumentsSA?._ADP_?.length > 1 ? uploadedDocumentsSA?._ADP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"ADP"}
                                    data-name={doc?.name}
                                    data-type="sa"
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload2.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload2.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                             {submitted && documentforSA?._ADP_?.length < 2 && uploadedDocumentsSA?._ADP_?.length < 2 && !disable && <p className="input-error" >Please upload ID proof of secondary Annutant</p>}
                            </div>
                            <div className="errormsg1 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      }
                      
                      {(paymentMethod === "cheque" && allJourneyData?.basicDetails.channel === "A") && <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Cheque Image</p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}>
                                <label className="choose-file-design">
                                  Upload
                                  <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    multiple
                                    onInput={e => uploadFile(e, "_COC_", true)}
                                    onKeyPress={(event) => handleFileEnter(event, 'file1')} tabIndex="0"
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  // required
                                  />
                                </label>
                                <span></span>
                              </div>
                              <div className="gallery"> </div>
                              <div className="upload-img icon-img">
                                {" "}
                                <img
                                  data-filename={responseDocument._COC_.fileName ? (journeyState.applicationNo + responseDocument._COC_.fileName) : uploadedDocuments?._COC_?.location}
                                  className="upload-document-img"
                                  data-doctype={"COC"}
                                  data-name={responseDocument._COC_.name || uploadedDocuments?._COC_?.name || "Uploaded file"}
                                  src={
                                    responseDocument._COC_.fileName
                                      ? isPdf(responseDocument._COC_.fileName)
                                        ? pdfIcon
                                        : responseDocument._COC_.location
                                      : uploadedDocuments?._COC_?.name
                                        ? isPdf(uploadedDocuments._COC_.name)
                                          ? pdfIcon
                                          : uploadedDocuments._COC_.path
                                        : withPrefix("/images/upload7.png")
                                  }
                                  aria-hidden="true"
                                  onClick={(e) => {
                                    if (responseDocument._COC_.fileName || uploadedDocuments?._COC_?.name) {
                                      if (isPdf(responseDocument._COC_.fileName || uploadedDocuments?._COC_?.name)) {
                                        openModal(e.target, "pdf")
                                      } else {
                                        openModal(e.target, "img")
                                      }
                                    }
                                  }}
                                />{" "}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {
                                submitted && !uploadedDocuments?._COC_?.name && !responseDocument._COC_.fileName && <p className="input-error" >Please upload Cheque Image</p>
                              }
                            </div>
                            <div className="errormsg clearfixerror"></div>
                          </div>
                        </div>
                      </div>}
                      {(paymentMethod === "dd" && allJourneyData?.basicDetails.channel === "A") && <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Demand Draft Image</p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}>
                                <label className="choose-file-design">
                                  Upload
                                  <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    multiple
                                    onInput={e => uploadFile(e, "_DDI_", true)}
                                    onKeyPress={(event) => handleFileEnter(event, 'file1')} tabIndex="0"
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  // required
                                  />
                                </label>
                                <span></span>
                              </div>
                              <div className="gallery"> </div>
                              <div className="upload-img icon-img">
                                {" "}
                                <img
                                  data-filename={responseDocument._DDI_.fileName ? (journeyState.applicationNo + responseDocument._DDI_.fileName) : uploadedDocuments?._DDI_?.location}
                                  className="upload-document-img"
                                  data-doctype={"DDI"}
                                  data-name={responseDocument._DDI_.name || uploadedDocuments?._DDI_?.name || "Uploaded file"}
                                  src={
                                    responseDocument._DDI_.fileName
                                      ? isPdf(responseDocument._DDI_.fileName)
                                        ? pdfIcon
                                        : responseDocument._DDI_.location
                                      : uploadedDocuments?._DDI_?.name
                                        ? isPdf(uploadedDocuments._DDI_.name)
                                          ? pdfIcon
                                          : uploadedDocuments._DDI_.path
                                        : withPrefix("/images/upload7.png")
                                  }
                                  aria-hidden="true"
                                  onClick={(e) => {
                                    if (responseDocument._DDI_.fileName || uploadedDocuments?._DDI_?.name) {
                                      if (isPdf(responseDocument._DDI_.fileName || uploadedDocuments?._DDI_?.name)) {
                                        openModal(e.target, "pdf")
                                      } else {
                                        openModal(e.target, "img")
                                      }
                                    }
                                  }}
                                />{" "}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {
                                submitted && !uploadedDocuments?._DDI_?.name && !responseDocument._DDI_.fileName && <p className="input-error" >Please upload Demand Draft Image</p>
                              }
                            </div>
                            <div className="errormsg clearfixerror"></div>
                          </div>
                        </div>
                      </div>}
                     
                      <div className="col-md-6">
                      <div className="upload-list-design">
                          <p>Fetch bank statement via finarkein</p>
                          <div className="upload-list">
                            <div>
                            <div
                                  className={isUploading ? "btn-disable" : ""}
                                >
                                  <label
                                    disabled={isUploading}
                                    className="choose-file-design"
                                    tabIndex="0"
                                    style={{
                                      border: "none",
                                    }}
                                    onKeyPress={(event) => handleNavigateFinarkein()}
                                    onClick={handleNavigateFinarkein}
                                  >
                                    {" "}
                                    Proceed
                                  </label>
                                </div>
                              <div className="gallery5 upload-img"> </div>
                              <div className="upload-img icon-img5">
                                {" "}
                                <img
                                  src={
                                      withPrefix("/images/upload3.png")
                                  }
                                />{" "}
                              </div>
                            </div>
                            <div className="errormsg5 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" && 
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p className="first-up-content">
                            Photograph of Proposer{" "}
                            <span>
                              {" "}
                              Latest within 3 month/ Upload full size Photograph
                            </span>
                          </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}>
                                <label className="choose-file-design">
                                  Upload
                                  <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    multiple
                                    onInput={e => uploadFileForProposer(e, "_PHO_",true)}
                                    onKeyPress={(event) => handleFileEnter(event, 'file1')} tabIndex="0"
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  // required
                                  />
                                </label>
                                <span></span>
                              </div>
                              <div className="gallery"> </div>
                              <div className="upload-img icon-img">
                                {" "}
                                <img
                                 data-filename = {responseDocumentProposer._PHO_.fileName ? (journeyState.applicationNo +  responseDocumentProposer._PHO_.fileName) : documentPR?._PHO_?.location}
                                 className="upload-document-img"
                                 data-doctype = {"PHO"}
                                 data-type="pr"
                                 doc-name = {responseDocumentProposer._PHO_.name || documentPR?._PHO_?.name || "Uploaded file"}
                                  src={
                                     responseDocumentProposer._PHO_.fileName
                                      ? isPdf(responseDocumentProposer._PHO_.fileName)
                                        ? pdfIcon
                                        : responseDocumentProposer._PHO_.location
                                      : documentPR?._PHO_?.name
                                      ? isPdf(documentPR._PHO_.name)
                                        ? pdfIcon
                                        : documentPR._PHO_.path
                                        : withPrefix("/images/upload1.png")
                                  }
                                  aria-hidden="true"
                                  onClick={(e) =>  {
                                    if (responseDocumentProposer._PHO_.fileName || documentPR?._PHO_?.name){
                                     if (isPdf(responseDocumentProposer._PHO_.fileName || documentPR?._PHO_?.name)){
                                       openModal(e.target,"pdf")
                                     }else{
                                       openModal(e.target,"img")
                                     }
                                    }
                                 }}
                                />{" "}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {
                                submitted && !documentPR?._PHO_.name && !responseDocumentProposer._PHO_.fileName && <p className="input-error" >Please upload Photograph of Proposer</p>
                              }
                            </div>
                            <div className="errormsg clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      }
                      <div className="col-md-6">
                        {/* <div className="upload-list-design">
                          <p>Account Details of Life Assured </p>
                          <div
                            className="upload-list"
                            style={{ height: "initial" }}
                          >
                            <div className="uprow elephant">
                              <img
                                src={withPrefix("/images/piggi-bank.png")}
                                style={{ borderRadius: "50%" }}
                              />
                              <span>
                                Account Details of Life Assured (where
                                refund/policy payout to made)- (Cancelled cheque/
                                Passbook/latest bank account statement)
                              </span>
                            </div>

                            <div>
                              <span style={{ marginTop: "2rem" }}>
                                Please choose Net Banking or Statement option in
                                case you want to upload document via Perfios
                              </span>
                              <form onSubmit={uploadFile}>
                                <input
                                  type="radio"
                                  name="perfiosUploadDocument1"
                                  id="uploadDocument1"
                                  onChange={changeBankingOption}
                                  onKeyPress={handleChangeBankingOption}
                                  value="netbankingFetch"
                                  tabIndex="0"
                                />
                                <label
                                  htmlFor="uploadDocument1"
                                  style={{
                                    marginRight: "1rem",
                                  }}
                                >
                                  Net Banking via Perfios
                                </label>

                                <input
                                  type="radio"
                                  name="perfiosUploadDocument1"
                                  id="uploadDocument2"
                                  onChange={changeBankingOption}
                                  onKeyPress={handleChangeBankingOption}
                                  value="statement"
                                  tabIndex="0"
                                />
                                <label htmlFor="uploadDocument2">
                                  Bank Statement Upload via Perfios
                                </label>
                              </form>
                            </div>
                            {errorState && (
                              <label className="input-error error">{errorState}</label>
                            )}
    
                            <div>
                              <div className="align-perfios-button">
                                <p>
                                  Upload latest bank account statement through
                                  Perfios
                                </p>
                                <div
                                  className={isUploading ? "btn-disable" : ""}
                                >
                                  <label
                                    disabled={isUploading}
                                    className="choose-file-design"
                                    tabIndex="0"
                                    style={{
                                      background: "transparent",
                                      height: "62px",
                                      paddingTop: 0,
                                    }}
                                    onKeyPress={(event) => handlePerfiosEnter(event)}
                                  >
                                    {" "}
                                    <button
                                      type="button"
                                      style={{ backgroundColor: "white" }}
                                      onClick={navigateToPerfiosUrl}
                                    >
                                      <img src={withPrefix("/images/perf-img.png")} />
                                    </button>
                                  </label>
                                </div>
                              </div>
                              <span style={{ marginLeft: "14rem" }}>OR</span>
                              <div className="align-perfios-button">
                                <p style={{ marginLeft: "6rem" }}>
                                  Upload documents manually
                                </p>
                                <div
                                  className={isUploading ? "btn-disable" : ""}
                                >
                                  <label
                                    disabled={isUploading}
                                    className="choose-file-design"
                                    tabIndex="0"
                                    onKeyPress={(event) => handleFileEnter(event, 'file7')}
                                  >
                                    {" "}
                                    Upload
                                    <input
                                      type="file"
                                      id="file7"
                                      name="file7"
                                      multiple
                                      onInput={e =>
                                        navigateToPerfiosUrl(e, "_BAS_")
                                      }
                                      accept="image/x-png,application/pdf,image/jpeg"
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="gallery7 upload-img"> </div>
                            <div className="errormsg7 clearfixerror"></div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </form>
                <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center-upload text-right">
                        <input
                          className="previous-btn cen"
                          style={digilockerLA ? {
                            background : "gray",
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                            cursor : "not-allowed"
                          } : {
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                          }}
                          disabled={digilockerLA}
                          onClick={digiLockerRedirection}
                          type="submit"
                          value="Submit Documents from digi locker for life assured"
                        />
                      </div>
                    </div>
                  </div>

              {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"  &&
                   <div className="iselect-mg-bottom hidden-desktop-screen">
                   <div className="col-md-12">
                     <div className="but-center-upload text-right">
                       <input
                         className="previous-btn cen"
                         style={digilockerPR ? {
                          background : "gray",
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          cursor : "not-allowed"
                        } : {
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                        }}
                         disabled={digilockerPR}
                         onClick={digiLockerRedirectionPR}
                         type="submit"
                         value="Submit Documents from digi locker for proposer"
                       />
                     </div>
                   </div>
                 </div>
                  } 
                  {allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02"  &&
                   <div className="iselect-mg-bottom hidden-desktop-screen">
                   <div className="col-md-12">
                     <div className="but-center-upload text-right">
                       <input
                         className="previous-btn cen"
                         style={digilockerSA ? {
                          background : "gray",
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          cursor : "not-allowed"
                        } : {
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                        }}
                         disabled={digilockerSA}
                         onClick={digiLockerRedirectionSA}
                         type="submit"
                         value="Submit Documents from digi locker for secondary annutant"
                       />
                     </div>
                   </div>
                 </div>
                  }

              {retreiveUploadedDocumentsData?.length > 0 && 
                    <div>
                      <h3>Please Download & Upload the journey Documents</h3>
                    {/* {
                      retreiveUploadedDocumentsData?.map((element, i)=> {
                        return(
                        <UploadDocumentsSigned key={i} data={element}/>
                      )
                      })                    
                    } */}
                    <div>
                    <SelectContainer>
                      <label >Please Select the Document</label>
                      <Select
                        options={docOptions}
                        name="Select"
                        key="Select"
                        id="InputSelect"
                        required={true}
                        tabIndex={-1}
                        value={selectedOption ? getKeyByValue(selectedOption, docOptions) : ""}
                        onChange={e => handleChange(e, retreiveUploadedDocumentsData)}
                      ></Select>
                    </SelectContainer>
                    {selectedOption &&
                          <div>
                            <div className="col-md-12">
                              <div className="pension18 row">
                                <div className="col-md-12">
                                  <div className="upload-list-design">
                                    <div className="upload-list">
                                      <div>
                                        <div className={isUploading ? "btn-disable" : ""}>
                                          <div >
                                            <label style={{marginRight:"10px"}}
                                              className="choose-file-design"
                                              onKeyPress={event => handleFileEnter(event, "file2")}
                                              tabIndex="0"
                                            >
                                              {" "}
                                              Download
                                              <input
                                                type="file"
                                                id="file2"
                                                name="file2"
                                                multiple
                                                // onInput={e => uploadFile(e, "_ADE_")}
                                                accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                                // required
                                                // required={!disable}
                                                onClick={e => downloadFile(e, selectedOptionData?.location)}
                                              />
                                            </label>
                                          </div>
                                          <div >
                                            <label style={{marginRight:"10px", marginLeft:"10px"}}
                                              className="choose-file-design"
                                              onKeyPress={event => handleFileEnter(event, "file2")}
                                              tabIndex="0"
                                            >
                                              {" "}
                                              Print
                                              <input
                                                type="file"
                                                id="file2"
                                                name="file2"
                                                multiple
                                                // onInput={e => uploadFile(e, "_ADE_")}
                                                accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                                // required
                                                // required={!disable}
                                                onClick={e => printFile(e, selectedOptionData?.location)}
                                              />
                                            </label>
                                          </div>
                                          <div >
                                            <label style={{marginLeft:"10px"}}
                                              className="choose-file-design"
                                              onKeyPress={event => handleFileEnter(event, "file2")}
                                              tabIndex="0"
                                            >
                                              {" "}
                                              Upload
                                              <input
                                                type="file"
                                                id="file2"
                                                name="file2"
                                                multiple
                                                onInput={e => uploadFile(e, selectedOptionData?.fileCode)}
                                                accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                                // required
                                                // required={!disable}
                                              />
                                            </label>
                                          </div>
                                        </div>
                                        {/* <div className="gallery1 upload-img"> </div> */}
                                        <div className="upload-img icon-img1">
                                          {" "}
                                          <img
                                            // src={ withPrefix("/images/upload51.png")
                                            src={
                                                responseDocument[selectedOptionData?.fileCode]
                                                    ? pdfIcon
                                                  : withPrefix("/images/upload51.png")
                                              }
                                            // }
                                          />{" "}
                                        </div>
                                      </div>
                                      <div className="errormsg1 clearfixerror"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                    }
                    </div>
                    </div>
                    
                  }

                  <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center-upload text-right">
                        <input
                          className="previous-btn cen"
                          style={{
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                          }}
                          onClick={handleSubmit}
                          type="submit"
                          value="Submit Documents"
                        />
                      </div>
                    </div>
                  </div>

                {/* <!--mobile view button--> */}
                <div className="iselect-mg-bottom show-in-mobile">
                    <div className="col-md-12">
                      <div className="but-center-upload text-right">
                        <input
                          className="previous-btn cen"
                          style={digilockerLA ? {
                            background : "gray",
                            color: "white",
                            padding: "14px 30px",
                            border: "none",
                            cursor : "not-allowed",
                            width : "100%",
                            fontSize : "12px"
                          } : {
                            color: "white",
                            padding: "14px 30px",
                            border: "none",
                            width : "100%",
                            fontSize : "12px"
                          }}
                          disabled={digilockerLA}
                          onClick={digiLockerRedirection}
                          type="submit"
                          value="Submit Documents from digi locker for life assured"
                        />
                      </div>
                    </div>
                  </div>

              {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"  &&
                   <div className="iselect-mg-bottom show-in-mobile">
                   <div className="col-md-12">
                     <div className="but-center-upload text-right">
                       <input
                         className="previous-btn cen"
                         style={digilockerPR ? {
                          background : "gray",
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          cursor : "not-allowed",
                          width : "100%",
                          fontSize : "12px"
                        } : {
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          width : "100%",
                          fontSize : "12px"
                        }}
                         disabled={digilockerPR}
                         onClick={digiLockerRedirectionPR}
                         type="submit"
                         value="Submit Documents from digi locker for proposer"
                       />
                     </div>
                   </div>
                 </div>
                  } 
                  {allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02"  &&
                   <div className="iselect-mg-bottom show-in-mobile">
                   <div className="col-md-12">
                     <div className="but-center-upload text-right">
                       <input
                         className="previous-btn cen"
                         style={digilockerSA ? {
                          background : "gray",
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          cursor : "not-allowed",
                          width : "100%",
                          fontSize : "12px"
                        } : {
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          width : "100%",
                          fontSize : "12px"
                        }}
                         disabled={digilockerSA}
                         onClick={digiLockerRedirectionSA}
                         type="submit"
                         value="Submit Documents from digi locker for secondary annutant"
                       />
                     </div>
                   </div>
                 </div>
                  }
                <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
                  <div className="iselect-mg-bottom">
                    <div className="col-md-12">
                      <div className="but-center text-center">
                        <div className="previous-btn cen">
                          <a style={{ width: "140px", padding: "14px 0px" }}>
                            {" "}
                            <button
                              type="submit"
                              value="button1"
                              style={{
                                backgroundColor: "transparent",
                                padding: "0px 0px",
                                border: "none",
                                color: "#fff",
                                width: "140px",
                                textAlign: "center"
                              }}
                              onClick={handleSubmit}
                            >
                              Submit Documents
                            </button>{" "}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--mobile view button-->  */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="imageModal" className="modal">
      
      <div className="imageContainer" style={{
        position : "relative",
        width : 'fit-content',
        marginLeft : "auto",
        marginRight : "auto",
        marginTop : "150px",
        background : "#eee"
      }}>
      <div className="previewImageBodyWrapper">
          <h4 className="previewImageHeading" id="image-preview-after-upload">Image Preview</h4>
          <div className="previewImageContainer">
          <img className="modal-content preview-img" id="modalImage"/>
            <div id="crossIconPreview" aria-hidden="true" onClick={() => closeModal()}>
              x
            </div>
            <div className="uploadButtonContainer">
              <button id="previewUpload2" onClick={(e) => {
                const type = e.target.getAttribute("data-type")
                deleteFile(e,type)
              }}>Delete</button>
            </div>
          </div>
        </div>
        
      </div>
      </div>
      {previewImgSrc && <div id="previewImageModal">
        <div className="previewImageBodyWrapper">
          <h4 className="previewImageHeading">Image Preview</h4>
          <div className="previewImageContainer">
            <img src={previewImgSrc}></img>
            <div id="crossIconPreview" aria-hidden="true" onClick={() => setPreviewImgSrc('')}>
              x
            </div>
            <div className="uploadButtonContainer" >
              <button id="previewUpload" onClick={(e) => {
                const type = e.target.getAttribute("data-type")
                if (type === "la"){
                  uploadFile(eventState,field,false)
                }else if (type === "pr"){
                  uploadFileForProposer(eventState,field,false)
                }else if (type === "sa"){
                  uploadFileForSA(eventState,field,false)
                }else{
                  return;
                }
                setPreviewImgSrc('')
              }}>Upload</button>
            </div>
          </div>
        </div>
      </div>}
    </>
  )
}
